import {
    ConversionApiCommandInput,
    ConversionApiEventType,
    TrackingTargetProviderEnum,
} from '@kidslabs/mario-client-event-tracking';
import {ConversionCustomData, MetaEventList} from '@/_application/modules/tracking/meta/model/meta-conversion';
import useEventTrackingService from '@/_application/modules/tracking/service/event-tracking.service';
import {
    getConversionApiInput,
    getConversionUserData,
    getCustomContentByEventName,
} from '@/_application/modules/tracking/meta/helper/conversion-api-meta';
import {Customer} from '@/__generated__/__types__';

const useConversionApi = () => {
    const {trackEventByConversionApi} = useEventTrackingService(TrackingTargetProviderEnum.FACEBOOK_CONVERSION);

    const sendProcessedDataToConversionAPI = (
        eventName: MetaEventList,
        input: any,
        customer: Customer,
        onAfterTracking?: () => void,
        ignoreTracking: boolean = true,
    ) => {
        if (ignoreTracking) {
            onAfterTracking && onAfterTracking();
            return;
        }
        const content: ConversionCustomData = getCustomContentByEventName(eventName, input);
        const userData = getConversionUserData(customer);

        const currentEventTimeTrack = Math.floor(Date.now() / 1000);

        const dataEvent: ConversionApiEventType = {
            event_name: eventName,
            event_id: `${eventName}_${customer?.phone_number}_${currentEventTimeTrack}`,
            event_time: currentEventTimeTrack,
            action_source: 'website',
            event_source_url: process.env.NEXT_PUBLIC_BASE_SHOP_URL_ENDPOINT ?? 'https://www.kidsplaza.vn/',
            user_data: userData,
            custom_data: content,
        };

        const trackingInput: ConversionApiCommandInput = getConversionApiInput(dataEvent);
        trackEventByConversionApi(trackingInput).finally(() => {
            onAfterTracking && onAfterTracking();
        });
    };

    return {
        sendProcessedDataToConversionAPI,
    };
};
export default useConversionApi;
